import { DataService } from '../../utils/dataService'
import { error } from '../../notifications/displayMessage'
import { AxiosResponse } from 'axios'
import { datadogLogs } from '@datadog/browser-logs'
export const START_HOME_IMAGE_CATALOGONAME = 'START_HOME_IMAGE_CATALOGONAME'
export const START_HOME_CLIENT_NAME = 'START_HOME_CLIENT_NAME'
export const LOAD_DATA_CLIENT_OWNER = 'LOAD_DATA_CLIENT_OWNER'
export const INACTIVE_CATALOGUE = 'INACTIVE_CATALOGUE'
export const INACTIVE_CATALOGUE_404 = 'INACTIVE_CATALOGUE_404'
export const WHATSAPP_BUTTON_CHANGE_POSITION = 'WHATSAPP_BUTTON_CHANGE_POSITION'
export const FOOTER_CHANGE_POSITION = 'FOOTER_CHANGE_POSITION'
export const SET_OUTSTANDING = 'SET_OUTSTANDING'
export const SET_OUTSTANDINGDATA = 'SET_OUTSTANDINGDATA'
export const SET_LANDING_LANGUAGE = 'SET_LANDING_LANGUAGE'

export const callData = (response: any, manage: number = 0) => async(dispatch: any) => {
  if (response && response.success) {
      if (response.success) { 
        if(manage === 1 || (response.data.catalogue.edataStatus ==='Permitido' && response.data.catalogue.statusCatalogue ==='activo')){
          dispatch({
            type: START_HOME_IMAGE_CATALOGONAME,
            payload: {...response.data.catalogue, manage}
          })
          
        }else{
          dispatch({
            type: INACTIVE_CATALOGUE
          })
        }
      } else if (response.cod_error === 404) {
        window.location.replace('/errors/error-404')
      } else if (response.titleResponse === "Este catálogo no existe") {
        dispatch({
          type: INACTIVE_CATALOGUE_404
        })
      } else {
        dispatch({
          type: INACTIVE_CATALOGUE
        })
      }
  } else {
    dispatch({
      type: INACTIVE_CATALOGUE
    })
  }
}
export const callDataOutstanding = (products: any) => async(dispatch: any) => {
  if(products.length > 0) {
    dispatch({
      type: SET_OUTSTANDING,
      payload: true
    })
    dispatch({
      type: SET_OUTSTANDINGDATA,
      payload: products
    })
  } else {
    dispatch({
      type: SET_OUTSTANDING,
      payload: false
    })
  }
}

export const callDataClient = (path: string) => async(dispatch: any) => {
  const _dataService = new DataService()
  const url = { url: path }
  await _dataService
    .post('/client/edit', url)
    .then((res: AxiosResponse) => {
      dispatch({
        type: START_HOME_CLIENT_NAME,
        payload: res.data.data
      })
    })
    .catch((err) => {
      error(`Ha ocurrido un error `)
      datadogLogs.logger.info('error request callDataClient', { name: 'post /client/edit', body: url, error: err.message })
    })
}

export const callDataConfingClientOwner = (path: string) => async(dispatch: any) => {
  const _dataService = new DataService()
  const url = { url: path,source:"apify" }
  await _dataService
    .post('/client/edit', url)
    .then((res: AxiosResponse) => {
      dispatch({
        type: LOAD_DATA_CLIENT_OWNER,
        payload: res.data
      })
    })
    .catch((err) => {
      error(`Ha ocurrido un error `)
      datadogLogs.logger.info('error request callDataConfingClientOwner', { name: 'post /client/edit', body: url, error: err.message })
    })
}

export const callLandingLanguage = (property: string) => {
  return {
    type: 'SET_LANDING_LANGUAGE',
    payload: property
  }
}

export const setWhatsappBottomSpacing = (margin: string | undefined) => ({
  type: 'WHATSAPP_BUTTON_CHANGE_POSITION',
  payload: margin
})


export const setFooterBottomSpacing = (margin: string | undefined) => ({
  type: 'FOOTER_CHANGE_POSITION',
  payload: margin
})


